export default __webpack_public_path__ + "df046c267d92fdc617e888dc1ca73c68.wav";